var _excluded = ["children", "color", "style", "tabularNumeric", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
// Libraries
import React from "react";

// Components
import MuiTypography from "@mui/material/Typography";

// Utilities

// TODO: [Typescript] Migrate this to @digital-hig/types

/**
 * @description digital-hig/typography
 *
 * @see Digital HIG Storybook: {@link https://storybook.digital-help-dev.autodesk.com/digital-hig/current/index.html?path=/docs/components-typography--api}
 */
var Typography = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    color = _ref.color,
    style = _ref.style,
    _ref$tabularNumeric = _ref.tabularNumeric,
    tabularNumeric = _ref$tabularNumeric === void 0 ? false : _ref$tabularNumeric,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'body-copy-medium' : _ref$variant,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  /**
   * Utility for color processing: Default color set in theme data. Header variant type overrides this, and color prop overrides that.
   */
  var processColorStyle = function processColorStyle(theme) {
    var colorStyle = null;
    if (variant && (variant.includes("display") || variant.includes("headline"))) {
      colorStyle = theme.tokens.colors["ink-on-background"];
    }
    if (color) {
      colorStyle = theme.tokens.colors[color];
    }
    return colorStyle;
  };
  return /*#__PURE__*/React.createElement(MuiTypography, _extends({
    ref: ref,
    variant: variant
  }, otherProps, {
    sx: [{
      color: function color(theme) {
        return processColorStyle(theme);
      }
    }, tabularNumeric && {
      fontVariantNumeric: "tabular-nums"
    }, style, otherProps.sx]
  }), children);
});
Typography.__docgenInfo = {
  "description": "@description digital-hig/typography\n\n@see Digital HIG Storybook: {@link https://storybook.digital-help-dev.autodesk.com/digital-hig/current/index.html?path=/docs/components-typography--api}",
  "methods": [],
  "displayName": "Typography",
  "props": {
    "tabularNumeric": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "variant": {
      "defaultValue": {
        "value": "'body-copy-medium'",
        "computed": false
      },
      "required": false
    }
  }
};
export default Typography;